"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAddBackorderDemandErrorResponse = exports.Name = exports.AddBackorderDemandFailedEvent = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'add-backorder-demand-failed';
const AddBackorderDemandFailedEvent = exports.AddBackorderDemandFailedEvent = Name;
const isAddBackorderDemandErrorResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isAddBackorderDemandErrorResponse = isAddBackorderDemandErrorResponse;
